<template>
  <div class="stock-modal-container" v-show="active" ref="main">
    <div class="stock-modal-content" :style="contentStyles">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
    },
  },
  methods: {
    checkOutFocus(evt) {
      if (!this.$refs.main || !this.$refs.main.contains(evt.target)) {
        this.$emit('close');
      }
    },
  },
  watch: {
    active(isActive) {
      if (isActive) {
        setTimeout(() => {
          document.addEventListener('click', this.checkOutFocus);
        }, 100);
      } else {
        document.removeEventListener('click', this.checkOutFocus);
      }
    },
  },
  computed: {
    contentStyles() {
      const style = {};
      if (this.minWidth) {
        style['min-width'] = this.minWidth;
      }
      return style;
    },
  },
};
</script>

<style scoped>

.stock-modal-container {
  position: relative;
  z-index: 459;
}

.stock-modal-content {
  position: absolute;
  margin-top: 5px;
  padding: 14px 14px 0 14px;
  background: #fff;
  border: none;
  border-radius: 5px;
  z-index: 459459;
  min-width: 100px;
  box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
}

@media screen and (max-width:767px) {
  .stock-modal-content {
    position: relative; 
    width: 100%;
    margin-top: 0px;
    background: #ffffbb;
    border-radius: 0px;
  }
}
</style>
